import styled from 'styled-components';

export const Dashboard = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

export const DashboardHeader = styled.div`
  margin-bottom: 30px;

  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`;

export const DashboardTitle = styled.h2`
  font-size: 28px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 8px;

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const DashboardSubtitle = styled.p`
  color: #64748b;
  font-size: 16px;

  @media (max-width: 480px) {
    font-size: 14px;
    line-height: 1.45;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: nowrap;
    gap: 12px;
    margin-bottom: 20px;
    overflow-x: auto;
    padding: 2px 2px 10px;
    scroll-snap-type: x proximity;
    scrollbar-width: thin;
  }
`;

export const StatCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 16px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  @media (max-width: 480px) {
    min-width: 176px;
    flex: 0 0 176px;
    padding: 14px;
    gap: 10px;
    scroll-snap-align: start;
  }

  @media (min-width: 481px) and (max-width: 768px) {
    min-width: 210px;
    flex: 0 0 210px;
    scroll-snap-align: start;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  }
`;

export const StatIcon = styled.div`
  font-size: 32px;
  width: 60px;
  height: 60px;
  background: #30D5C8;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex: 0 0 60px;

  @media (max-width: 480px) {
    width: 44px;
    height: 44px;
    flex-basis: 44px;
    font-size: 23px;
  }
`;

export const StatContent = styled.div`
  flex: 1;
`;

export const StatValue = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const StatTitle = styled.div`
  font-size: 14px;
  color: #64748b;
  margin-bottom: 8px;
`;

export const StatChange = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  border-radius: 6px;
`;

export const PositiveChange = styled(StatChange)`
  background: #dcfce7;
  color: #166534;
`;

export const NegativeChange = styled(StatChange)`
  background: #fee2e2;
  color: #991b1b;
`;

export const DashboardContent = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(280px, 1fr);
  gap: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const DashboardSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;

  @media (max-width: 480px) {
    padding: 16px;
    overflow-x: auto;
  }
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const ViewAllButton = styled.button`
  background: none;
  border: none;
  color: #3b82f6;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #f0f9ff;
  }
`;

export const OrdersTable = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  font-size: 14px;
  color: #64748b;

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
  font-size: 14px;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 8px;
  }
`;

export const OrderId = styled.span`
  font-weight: 600;
  color: #3b82f6;
`;

export const Customer = styled.span`
  color: #334155;
`;

export const Amount = styled.span`
  font-weight: 600;
  color: #26a79d;
`;

export const SalesTable = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 360px;
`;

export const SalesTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 1fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 600;
  font-size: 14px;
  color: #64748b;
`;

export const SalesTableRow = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 1fr;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 1px solid #f1f5f9;
  align-items: center;
  font-size: 14px;
  color: #334155;

  &:last-child {
    border-bottom: none;
  }
`;

export const EmptyState = styled.div`
  padding: 28px 0;
  color: #64748b;
  font-size: 14px;
  text-align: center;
`;

export const Status = styled.span`
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
`;

export const CompletedStatus = styled(Status)`
  background: #dcfce7;
  color: #166534;
`;

export const ProcessingStatus = styled(Status)`
  background: #fef3c7;
  color: #92400e;
`;

export const PendingStatus = styled(Status)`
  background: #f3f4f6;
  color: #374151;
`;

export const QuickActions = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ActionButton = styled.button`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;

  &:hover {
    background: #f1f5f9;
    border-color: #cbd5e1;
    transform: translateY(-1px);
  }
`;

export const ActionIcon = styled.span`
  font-size: 24px;
`;

export const ActionLabel = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #334155;
`;
